import BaseModelAPI from '../BaseModelAPI';

export default class CompanyInfo extends BaseModelAPI {
	static entity = 'companyinfo';
	static entityName = 'companyinfo';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.companyName = '';
			this.corporateField = '';
			this.companyAddress = '';
			this.officePhoneNumber = '';
			this.officeFax = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}